import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";

const ProductModal = ({ show, onHide, onSave, product, categories }) => {
  const [name, setName] = useState("");
  const [category, setCategory] = useState(categories[0] || "");
  const [price, setPrice] = useState("");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState("");
  console.log("image", image);

  useEffect(() => {
    if (product) {
      setName(product.name);
      setCategory(product.category);
      setPrice(product.price);
      setImage(product.image);
      setPreview(product.image);
    } else {
      setName("");
      setCategory(categories[0] || "");
      setPrice("");
      setImage(null);
      setPreview("");
    }
  }, [product, categories]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = () => {
    if (!name || !price || !category) {
      Swal.fire("Error", "All fields are required!", "error");
      return;
    }

    onSave({
      id: product ? product.id : Date.now(),
      name,
      category,
      price: parseFloat(price),
      image: preview, // Simpan URL gambar untuk sementara (Bisa diubah ke API upload nanti)
    });

    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{product ? "Edit Product" : "Add Product"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Product Name</Form.Label>
            <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Price</Form.Label>
            <Form.Control type="number" value={price} onChange={(e) => setPrice(e.target.value)} min={0} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Category</Form.Label>
            <Form.Select value={category} onChange={(e) => setCategory(e.target.value)}>
              {categories.map((cat, index) => (
                <option key={index} value={cat}>{cat}</option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Upload Image</Form.Label>
            <Form.Control type="file" accept="image/*" onChange={handleImageChange} />
          </Form.Group>

          {preview && (
            <div className="mb-3 text-center">
              <img src={preview} alt="Preview" style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "5px" }} />
            </div>
          )}

          <Button variant="primary" onClick={handleSubmit}>Save</Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ProductModal;
